import React from "react";
import Layout from "../../components/Layout";
import OpenGraphTitle from "../../components/OpenGraphTitle";
import OpenGraphDescription from "../../components/OpenGraphDescription";
import Head from "../../components/head";
import { ServicesPageProvider } from "../../context/ServicesPageContext";
import FranchiseContext, { FranchiseeProvider } from "../../context/Franchisee";
import ServiceTitle from "../../components/ServiceTitle";
import ServicesDescription from "../../components/ServicesDescription";
import Link from "next/link";
import ContactUs from "../../components/ContactUs";
import ComparisonTable from "../../components/ComparisonTable";
import data from "../../data/services-comparison.json"

interface RecurringCleanPageProps {
  /* add services page props here */
}

const RecurringClean: React.FC<RecurringCleanPageProps> = () => (
  <FranchiseeProvider>
    <ServicesPageProvider>
      <Layout alternateFooter={true}>
        <Head
          slug="recurring-clean"
          title="Recurring Cleaning Services - Two Maids"
          description="Our Recurring Clean Services are designed to ensure your home remains clean with regular, comprehensive cleaning. "
        />
        <OpenGraphTitle title="Recurring Cleaning Services - Two Maids" />

        <OpenGraphDescription>
          Our Recurring Clean Services are designed to ensure your home remains clean with regular, comprehensive cleaning. 
        </OpenGraphDescription>

        <ServiceTitle imageSrc="https://res.cloudinary.com/twomaidsengi/image/upload/v1724956000/hubsite-reskin/New%20Services%20Pages/Recurring-Cleaning.webp">Recurring Cleaning</ServiceTitle>
        <div className="service-description gray-background">
          <h2>Recurring Cleaning Services</h2>
          <p>
            Our Recurring Cleaning Services are designed to ensure your home remains clean with regular, comprehensive cleaning. We 
            offer thorough cleaning for key areas such as kitchens, bathrooms, bedrooms, and common areas, with a proven system to 
            maintain an overall high standard of cleanliness. Enjoy the peace of mind that comes with a consistently clean and welcoming home. 
          </p>
        </div>
        <ServicesDescription colSize={12} className="service-description-table-container">
          <h2 className="service-description-title">What’s Included?</h2>
          <ComparisonTable
            rows={data}
          />
        </ServicesDescription>
        <ServicesDescription>
          <h3 className="service-description-title">Why Two Maids?</h3>
          <p>
            Your home will receive the highest level of care from our fully licensed, bonded, and insured teams. We offer customizable
            services to meet your specific needs.
          </p>
          <p>
            In addition to providing the right package for you, we are committed to sending only our trained cleaning professionals, who
            are passionate about their work and dedicated to excellence. At Two Maids, we foster a culture of compassion,
            interconnectedness, and grit, creating a welcoming and supportive environment for both our team and clients.
          </p>
        </ServicesDescription>
        <ContactUs
          title="Contact Us"
          titleClassName="align-items-center"
          buttons={
            <FranchiseContext.Consumer>
              {({ franchisee }) =>
                <Link href={
                  franchisee?.id > -1
                    ? `/${franchisee?.slug}/contact/`
                    : '/'
                }>
                  <a className="contact-us-button">REACH OUT</a>
                </Link>}
            </FranchiseContext.Consumer>
          }
        >
          <p className="p-3">
            Ready to let life shine in your home? Contact us today to schedule your house cleaning service and
            experience the Two Maids difference. Our friendly, professional teams are here to make your home sparkle!
          </p>
        </ContactUs>
      </Layout>
    </ServicesPageProvider>
  </FranchiseeProvider>
);
export default RecurringClean;
